import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-pfeil-grau",
  "use": "various-pfeil-grau-usage",
  "viewBox": "0 0 33 33",
  "content": "<symbol viewBox=\"0 0 33 33\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-pfeil-grau\"><path d=\"M23 16L11.915 5 10 6.9l9.17 9.1L10 25.1l1.915 1.9z\" fill=\"#2D2D2D\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol